<template>
  <el-card>
    <template slot="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Finance' }">Finance</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-button @click="() => $router.push({ name: 'Facility Finance collections' })">
      Collections
    </el-button>
    <el-button @click="() => $router.push({ name: 'Facility Finance report' })">
      Accrual Report
    </el-button>
    <el-button @click="() => $router.push({ name: 'Facility Finance revision' })">
      Revised by Month
    </el-button>
    <el-button @click="() => $router.push({ name: 'Facility Finance deposits' })">
      Deposits
    </el-button>
    <el-button @click="() => $router.push({ name: 'Facility Finance sales' })">
      Sales Tax
    </el-button>
    <el-button @click="() => $router.push({ name: 'Facility Finance Move in' })">
      Move In - Move Out
    </el-button>
  </el-card>
</template>

<script>
export default {
  name: 'Finance Facility',
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FinanceFacility.vue